import React, { useState } from "react";
import Typewriter from '../typewriter';
import './text.css';

function text() {
    return (
        <div className="about-info">
            <main class="text-white">
                <section className="items-center">
                    <span class="font-normal tracking-widest lg:text-2xl sm:text-xl welcome-text">Hi<span class="wave" role="img">👋</span>‎‎‏‏‎ ‎‏‏‎! I’m </span>
                    <h1 class="font-bold text-pink-500 text-9xl text-class">
                        Sid.
                    </h1>
                    <p class="typewrite-text text-gray-200"><Typewriter /></p>
                </section>
            </main>
        </div>
    )
}

export default text
